import './GoodToKnow.css';
export default {
    "goodToKnow": "GoodToKnow_goodToKnow__ramez"
};
